
/* Library */
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import InputButton from '../../../../../components/ZUILib/InputButton';
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import Pagination from '../../../../../components/Pagination';
import * as predeterminedListsActions from '../actions';
import commonUtil from '../../../../../utils/commonUtil';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
import ApplyCSS from '../../../../../components/ApplyCSS';
import Tagging from '../../../../../components/Tagging/Tagging';
import RadioButton from '../../../../../components/ZUILib/RadioButton';

const applicationRoutes = commonUtil.getApplicationRoutes();

const pageName = 'PredeterminedLists';


const {
  getpredeterminedListPageHeaderInfo,
  getPredeterminedListPageItemsInfo,


  } = predeterminedListsActions;

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,

}),

  {
    ...predeterminedListsActions,
  })

class PredeterminedListsDetailsWeb extends Component {
  constructor(props) {
    super(props);
    this.catId = '';
    this.price = '';
    this.currentPage = 1;
    this.state = {
      sortingType: '',
      filteredData: '',
      filteredCategoryValue: '',
    };
    this.deliveryMode = 'physical';
    this.itemName = '';
   
  }

  handleAddListToMyList = (repoId, itemName, deliveryMode) => {
    const _dataLayer = {};
    _dataLayer.event = 'evGiftList';
    _dataLayer.nameList = itemName;
    _dataLayer.selectOption = 'Agregar Artículos a mi lista';
    this.tagging.applyGTM('evGiftList', _dataLayer);
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregar artículos a mi lista';
    dataLayer.eventLabel = 'Regalos '+deliveryMode;
    dataLayer.dimension77 = 'Preferencia de regalo';
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    this.props.onAddListToMyList(repoId, this.props.eventId,deliveryMode);
  }
  showAddModalType = () =>{
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregar artículos a mi lista';
    dataLayer.eventLabel = this.itemName;
    dataLayer.dimension77 = 'Listas Predeterminadas';
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    const dataLayer2 = {};
    dataLayer2.event =  'Mesa de Regalos';
    dataLayer2.eventCategory= 'Mesa de Regalos';
    dataLayer2.eventAction = 'Agregar artículos a mi lista';
    dataLayer2.eventLabel = 'Preferencia de regalo';
    this.tagging.applyGTM('Mesa de Regalos', dataLayer2);
    this.addGiftModalType.handleShow();
  }
  showAddModal = () => {
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregaste a tu mesa de regalos';
    dataLayer.eventLabel = 'Regalos '+ this.deliveryMode;
    dataLayer.dimension77 = this.itemName;
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    this.addGiftModal.handleShow();
  }
  backToPredetermined = () => {
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregaste a tu mesa de regalos';
    dataLayer.eventLabel = 'Continuar agregando regalos';
    dataLayer.dimension77 = this.itemName;
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.predeterminedLists, { eventType: this.eventTypeSonam, eventID: this.props.eventId }));
    this.addGiftModal.handleHide();
  }
  backToAdminPage = () => {
    const dataLayer = {};
    dataLayer.event =  'Mesa de Regalos';
    dataLayer.eventCategory= 'Mesa de Regalos';
    dataLayer.eventAction = 'Agregaste a tu mesa de regalos';
    dataLayer.eventLabel = 'Ir a mi mesa de regalos';
    dataLayer.dimension77 = this.itemName;
    this.tagging.applyGTM('Mesa de Regalos', dataLayer);
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: this.props.eventId }));
    this.addGiftModal.handleHide();
  }

  UNSAFE_componentWillMount() {
    this.props.getpredeterminedListPageHeaderInfo(this.props.params.repoId);
    this.props.getPredeterminedListPageItemsInfo(this.props.params.repoId, '1');
  }
  componentWillReceiveProps(nextProps) {
    this.predeterminedItemInfo = nextProps.predeterminedHeaderInfo ?
      nextProps.predeterminedHeaderInfo.predeterminedItemInfo : null;

    this.categoryList = nextProps.predeterminedItemsDetailsInfo ?
      nextProps.predeterminedItemsDetailsInfo.categoryList : null;

    this.pagerecords = nextProps.predeterminedItemsDetailsInfo ?
      nextProps.predeterminedItemsDetailsInfo : null;
    this.categoryItemsInfo = nextProps.predeterminedItemsDetailsInfo ?
      nextProps.predeterminedItemsDetailsInfo.itemsInfo : null;

  }


  filterAndSorting = (e) => {
    const catId = this.categoryTypeFilter.getID();
    const price = this.sortProductByPrice.getID();


    this.props.getPredeterminedListPageItemsInfo(this.props.params.repoId, '1', (catId || ''), (price || ''));
    if (catId !== '') {
      if (e.value !== 'HighToLow' && e.value !== 'LowToHigh' && e !== 'Ordenar por precio') {
        this.first.style.display = 'block';
        this.setState({
          filteredCategoryValue: e.value,
        });
      }
    } else {
      this.first.style.display = 'none';
      this.setState({
        filteredCategoryValue: e.value,
      });
    }
  }

  onPageChange = (value) => {
    this.props.getPredeterminedListPageItemsInfo(this.props.params.repoId, (value).toString(), (this.catId || ''), (this.price || ''));
  }
  _setDeliveryMode = (ref) => {
    this.deliveryMode = ref.value;   
  }
  generateHeaderInfo = (predeterminedItemInfo) => {
    const label = this.props.labels;
    const addListInGiftList = {
      name: 'Agregar artículos a mi lista',
      style: 'btnPrimary size-Large',
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
      value: commonUtil.getLabel(label.PredeterminedPage, 'predetermine.addtolist.button.label'),
      // onClickHandler: this.handleAddListToMyList,
    };
    const continueAddingGift = {
      name: 'Continuar agregando regalos',
      style: 'btnPrimary size-Full',
      type: 'button',
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
      value: commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.continue.button.label'),
      onClickHandler: this.backToPredetermined,

    };
    const goToMyGiftTable = {
      name: 'Ir a mi mesa de regalos', 
      style: 'btnPrimarySpecial size-Full mt10',
      type: 'button',
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
      value: commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.gotogifts.button.label'),
      onClickHandler: this.backToAdminPage,
    };
    const continueAddingGiftType = {
        name: 'Continuar',
        style: 'btnPrimary size-Medium',
        type: 'button',
        value: 'Continuar',
      };
    const addPredeterminedItemInfo = this.props.addPredeterminedItemInfo ? this.props.addPredeterminedItemInfo[0] : null;
    this.eventTypeSonam = this.props.eventTypeValue && this.props.eventTypeValue.eventType ? this.props.eventTypeValue.eventType : '';
    const _typeListPredetermined = {
        htmlId: 'typeListPredetermined',
        title: 'Tipo Lista',
        displayName: 'Tipo Lista',
        name: 'typeListPredetermined',
        defaultValue: 'physical',
        options: [
          {
            id: 'typePhysical',
            value: 'physical',
            title: 'Regalos fisicos',
            displayName: 'Regalos fisicos',
            labelResourceId: 'Regalos fisicos',
            selected: true,
          },
          {
            id: 'typeElectronic',
            value: 'electronic',
            title: 'Regalos electrónicos',
            displayName: 'Regalos electrónicos',
            labelResourceId: 'Regalos electronicos',
          },
        ],
      };

    // const eventTypeSonam = this.eventTypeValue && this.props.eventTypeValue.eventInfo && this.props.eventTypeValue.eventInfo ? this.props.eventTypeValue.eventInfo.eventType : '';
    if (predeterminedItemInfo) {
      return predeterminedItemInfo.map((predeterminedItemInfor, index) => {
        
        const newAddListInGiftList = Object.assign({}, addListInGiftList);
        newAddListInGiftList.onClickHandler = () => { 
            this.itemName = predeterminedItemInfor.itemName;
            this.showAddModalType(this.itemName);
        };
        const newAddListInGiftListType = Object.assign({}, continueAddingGiftType);
        newAddListInGiftListType.onClickHandler = () => {
            this.itemName = predeterminedItemInfor.itemName;
            this.addGiftModalType.handleHide(); this.showAddModal(); this.handleAddListToMyList(predeterminedItemInfor.repoId, predeterminedItemInfor.itemName,this.deliveryMode); 
        };
        
        return (<div key={index}>
          <div className="col-sm-8">
            <Tagging ref={tagging => this.tagging = tagging} />
            <h1 className="titleSection">{predeterminedItemInfor.itemName.toUpperCase()} </h1>
            <h2 className="subtitleModule">{predeterminedItemInfor.noOfItems} <span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.total.articles')}</span></h2>
            <h2 className="subtitleModule">{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.gifts.label1')}<span> {commonUtil.getCurrency(predeterminedItemInfor.minPrice)}</span> {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.gifts.label2')}<span> {commonUtil.getCurrency(predeterminedItemInfor.maxPrice)}</span></h2>
            <h3>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.total.label')} <span>{commonUtil.getCurrency(predeterminedItemInfor.totalPrice)}</span></h3>
          </div>
          <div className="col-sm-4">
            <InputButton buttonAttr={newAddListInGiftList} />
          </div>
          <div id="myModalAddList">
          <ModalPopover
              ref={add => this.addGiftModalType = add}
              isModal="true" outerClass="modal-sm" modalId="predeter-con-pop"
            >
              <div className="row">
                <div className="col-md-12">
                <button className="close" id="closeModal" type="button" data-dismiss="modal">×</button>
                    <p><b>Preferencia de regalo</b></p>
                    <hr/>
                    <p>Quiero  que los regalos de esta lista me lleguen como:</p>
                </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-sm-offset-3">
                        {_typeListPredetermined.options.map(option => (
                        <p>
                            <RadioButton displayName={option.displayName} radioCssClass={'radio'} name={_typeListPredetermined.name} onChangeFunction={this._setDeliveryMode} value={option.value} checked={option.selected ? _typeListPredetermined.defaultValue === option.value : false} />
                        </p>
                        ))}
                        <p>
                        <InputButton buttonAttr={newAddListInGiftListType} />
                        </p>
                    </div>
                </div>
            </ModalPopover>
            <ModalPopover
              ref={add => this.addGiftModal = add}
              isModal="true" outerClass="modal-lg" modalId="predeter-con-pop"
            >
              <button className="close" id="closeModal" type="button" data-dismiss="modal">×</button>
              <div className="alert-container"><i className="icon-estado_de_mensaje_aprobado" />
                <p className="txt-alert">{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.message')} &nbsp; 1 <span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermined.list.label')}</span>&nbsp; {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.message1')}</p>
              </div>
              {addPredeterminedItemInfo ?
                <div className="row">
                  <div className="col-xs-4">
                    <div className="imgList" />
                    {addPredeterminedItemInfo.imageURL ? <img src={addPredeterminedItemInfo.imageURL} className="img-responsive" /> : <img src={commonUtil.getAssetURL() + '/images/ooooooooooo.jpg'} className="img-responsive" />}
                  </div>
                  <div className="col-xs-4">
                    <div className="descriptionList">

                      <h4 className="title">{addPredeterminedItemInfo && addPredeterminedItemInfo.itemName && addPredeterminedItemInfo.itemName.toUpperCase()}</h4>
                      <p className="articles"><span>{addPredeterminedItemInfo.noOfItems}</span><span> {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.total.articles')}</span></p>
                      <p className="priceRange"><span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.gifts.label1')} {commonUtil.getCurrency(addPredeterminedItemInfo.minPrice)} {commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.gifts.label2')} {commonUtil.getCurrency(addPredeterminedItemInfo.maxPrice)}</span></p>
                      <p><span>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.successpage.total.label')}</span><span className="value">{commonUtil.getCurrency(addPredeterminedItemInfo.totalPrice)} {addPredeterminedItemInfo.itemId}</span></p>
                      <p className="priceRange giftPreference"><span>Preferencia de regalo:</span></p>
                      <p className="giftElectronicPhysical"><span>Regalos {this.deliveryMode == 'electronic' ? 'electrónicos' : 'físicos' }</span></p>
                    </div>
                  </div>
                  <div className="col-xs-4 buttons">
                    <InputButton buttonAttr={continueAddingGift} />
                    <br />
                    <InputButton buttonAttr={goToMyGiftTable} />
                  </div>
                </div> : null}
            </ModalPopover>
          </div>
        </div>);
      });
    }
    return null;
  }


  render() {
    const addPredeterminedItemInfo22 = this.eventTypeValue;


    const addPredeterminedItemInfo = this.props.addPredeterminedItemButton ? this.props.addPredeterminedItemButton.predeterminedItemInfo : null;
    const addPredeterminedItemInfoData = this.props.addPredeterminedItemInfo ? this.props.addPredeterminedItemInfo[0] : null;
    const label = this.props.labels;

    if (!this.predeterminedItemInfo && !this.categoryList && !this.categoryItemsInfo && !addPredeterminedItemInfo && !this.pagerecords) {
      return null;
    }
    const categoryList = this.categoryList ? this.categoryList.map(selectedCelebratedName => ({ id: selectedCelebratedName.catId, value: selectedCelebratedName.catName })) : [];
    const pagerecords = this.pagerecords;

    const paginationInfo = {
      totalNoOfRecords: pagerecords ? pagerecords.totalRecords : '',
      recordsPerPage: pagerecords ? pagerecords.recordsPerPage : '',
      currentPage: pagerecords ? pagerecords.currentPage : '',

    };


    const PriceBasedSorting = {
      options: [{
        id: 'Ascending',
        value: 'LowToHigh',
        labelResourceId: commonUtil.getLabel(label.PredeterminedPage, 'predetermined.price.lower.to.high'),
        disabled: false,
      }, {
        id: 'Descending',
        value: 'HighToLow',
        labelResourceId: commonUtil.getLabel(label.PredeterminedPage, 'predetermined.price.high.to.lower'),
        disabled: false,
      }],
    };


    return (
      <div className="container wrapCLP">
        <div className="row itemsDefaultList">
          <ApplyCSS pageName={pageName} />

          {this.generateHeaderInfo(this.predeterminedItemInfo)}


          <div className="col-sm-12">
            <div className="defaultListFilter">
              <label>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.filter.label')}</label>
              <SelectionTab
                id="sortProductByPrice"
                classname="cSelect filters"
                isCaptionDisabled={false}
                optionCaption={commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.price.dropdown.label')}
                options={PriceBasedSorting.options}
                optionText={'labelResourceId'}
                optionValue={'value'}
                handleSelectedOption={this.filterAndSorting}
                ref={refs => this.sortProductByPrice = refs}
              />
              <SelectionTab
                id="categoryTypeFilter"
                classname="cSelect filters"
                isCaptionDisabled={false}
                optionCaption={commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.categoty.dropdown.label')}
                options={categoryList}
                optionText={'value'}
                optionValue={'value'}
                handleSelectedOption={this.filterAndSorting}
                ref={refs => this.categoryTypeFilter = refs}
              />

            </div>
          </div>
          <div className="col-sm-12">
            <h4 className="informativeTextSecond" ref={first => this.first = first} style={{ display: 'none' }}>{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.category.label')}<span>{this.state.filteredCategoryValue} </span></h4>
            <div className="defaultListPagination">
              {pagerecords && pagerecords.totalRecords && (pagerecords.totalRecords > pagerecords.recordsPerPage) ?
                <Pagination paginationInfo={paginationInfo} onPageChange={this.onPageChange} prevLabel={commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.startpage.label')} nextLabel={commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.endpage.label')} /> : null}
            </div>
          </div>
          <div className="col-sm-12">
            <div className="row defaultListProducts" >
              {this.categoryItemsInfo && this.categoryItemsInfo.map(info => (
                <div className="col-sm-2 product">
                  {info.imageURL ? <img src={info.imageURL} /> : <img src={commonUtil.getAssetURL() + '/images/89843855 (1).jpg'} />}
                  <p className="informativeText">{info.itemName}</p>
                  <p className="descriptiveTextSecond">{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.prodcut.code.label')} <span>{info.productCode}</span></p>
                  <p className="quantityAndGuest">{commonUtil.getCurrency(info.price)}</p>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>

    );
  }
}
const mapStateToProps = state => ({
  myData: state,
  eventTypeValue: state.giftList.data && state.giftList.data.eventSummaryInfo && state.giftList.data.eventSummaryInfo.eventInfo,
  predeterminedHeaderInfo: state.predeterminedLists.data && state.predeterminedLists.data.predeterminedHeaderInfo,
  predeterminedItemsDetailsInfo: state.predeterminedLists.data && state.predeterminedLists.data.predeterminedItemsDetailsInfo,

});
const matchDispatchToProps = dispatch => bindActionCreators({

  getpredeterminedListPageHeaderInfo,
  getPredeterminedListPageItemsInfo,


}, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(PredeterminedListsDetailsWeb);

